export enum TokeniserSite {
  Platform = 'platform',
  PlatformSecurity = 'platform-security',
  PlatformAddCard = 'platform-add-card',
  PlatformEditCard = 'platform-edit-card',
  PlatformPayWithPoints = 'platform-pay-with-points',
}
